import React from 'react'
import PropTypes from 'prop-types';
import {NewsItem} from './NewsItem'
import MotionScroll from '../HomeView/MotionScroll';

export class NewsView extends React.Component {
  constructor (props) {
    super(props)
    this.clickArrow = this.clickArrow.bind(this)
    this.current_page=0

    this.news_list = null;
    this.state = {
      spos: 0,
    }
  }

  componentDidMount () {

  }

  componentWillReceiveProps (nextProps) {
    this.current_page=0
    this.toggleArrows(nextProps)
    //var jqEl = $(this.refs.news_list)
    //jqEl.animate({scrollLeft: 0})
    this.setState({
      spos: 0,
    })
  }

  toggleArrows (inprops) {
    const {news} = inprops
    let maxpages = Math.ceil(news.length / 3) // colocar isto dinamico
    if (window.innerWidth < 600) {
      maxpages = news.length
    }
    if ((maxpages > 1) && (this.current_page < (maxpages-1))) {
      this.refs.right_arrow_ico.classList.remove('hide')
    } else {
      this.refs.right_arrow_ico.classList.add('hide')
    }

    if (parseInt(this.current_page, 10) !== 0) {
      this.refs.left_news_arrow_ico.classList.remove('hide')
    } else {
      this.refs.left_news_arrow_ico.classList.add('hide')
    }

    if (maxpages === 0) {
      this.refs.left_news_arrow_ico.classList.add('hide')
      this.refs.right_arrow_ico.classList.add('hide')
    }
  }

  clickArrow (direction) {
    // console.log('NewsView clickArrow')
    const news_list = this.refs.news_list
    console.log('news_list', this.news_list);

    if (direction === 'right') {
      this.current_page++
    } else {
      this.current_page--
      if (this.current_page < 0) {
        this.current_page = 0
      }
    }

    this.toggleArrows(this.props)
    //jqEl.animate({scrollLeft: this.current_page * news_list.clientWidth})

    this.setState({
      spos: this.current_page * this.news_list.clientWidth,
    })


    setTimeout(function () {
      window.dispatchEvent(new Event('resize'))
    }, 400)
  }

  render () {
    const {news, isFetchingNews} = this.props
    var leftArrowClick = this.clickArrow.bind(this, 'left')
    var rightArrowClick = this.clickArrow.bind(this, 'right')

    return (
      <div id='news-view' className='row'>
        <div className='col-md-12'>
          <p className='section-title'>NOTÍCIAS</p>
        </div>
        <div ref='left_news_arrow'
          className='col-xs-1 text-center no-pad-right' onClick={leftArrowClick}>
          <span ref='left_news_arrow_ico' className='arrow glyphicon glyphicon-chevron-left hide'
            aria-hidden='true'></span>
        </div>

        <div id='news_list' ref={(n) => this.news_list = n} className='col-xs-10 no-pad nowrap'
          style={{
            opacity: isFetchingNews ? 0.5 : 1,
            //transform: `translateX(${interpolatingStyle.x}px)`
          }}>
            {isFetchingNews && news.length === 0 &&
              <h4>Loading...</h4>
            }
            {!isFetchingNews && news.length === 0 &&
              <h4>Empty.</h4>
            }
            {news.map((news_item, i) =>
              <NewsItem grid_size={3} news={news_item} key={i} />
              )
            }
        </div>

        <MotionScroll scrollLeft={this.state.spos} el={this.news_list}/>

        <div ref='right_news_arrow'
          className='col-xs-1 text-center no-pad-left' onClick={rightArrowClick}>
          <span ref='right_arrow_ico' className='arrow glyphicon glyphicon-chevron-right' aria-hidden='true'></span>
        </div>
      </div>
    )
  }
}

NewsView.propTypes = {
  isFetchingNews: PropTypes.bool.isRequired,
  news: PropTypes.array.isRequired
}



// WEBPACK FOOTER //
// ./src/views/NewsView/NewsView.js